import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { fieldFilter } from '../FieldFilter';
import { categoryFilter } from '../CategoryFilter';
import { product } from '../Product';

const body = z
    .object({
        productIds: z.array(z.string()),
        excludedProductIds: z.array(z.string())
    })
    .strict();

export const productGetSuggestedResult = z
    .object({
        suggestedProducts: z.array(product),
        suggestedFieldFilters: z.array(fieldFilter),
        suggestedCategoryFilters: z.array(categoryFilter)
    })
    .strict();

export const productGetSuggested = {
    verb: 'post',
    path: 'get-suggested',
    schema: {
        body,
        response: {
            200: productGetSuggestedResult
        }
    }
} as const satisfies EndpointContract;

export type ProductGetSuggestedResult = z.TypeOf<
    typeof productGetSuggestedResult
>;
